// Material ui components
import { useQuery } from '@apollo/client';
import { Box, Divider, Grid, makeStyles, Typography } from '@material-ui/core';

// Global components
import PaperPanelInfo from '../../../../../components/PaperPanelInfo';
// Apollo client
import ipanema from '../../../../../graphql/clients/ipanema';
import { GET_CRA_RECEIVABLES_BY_OPERATION_HASH_ID } from '../../../../../graphql/queries';

//Styles
const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  divider: {
    height: 2,
    backgroundColor: theme.palette.common.black,
  },
  box: {
    borderLeft: `6px solid ${theme.palette.secondary.main}`,
  },
  infoOutlinedIcon: {
    fontSize: '1rem',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export default function OperationCRAResumeReceivables({ hashId }) {
  const classes = useStyles();
  const { data, loading, error } = useQuery(
    GET_CRA_RECEIVABLES_BY_OPERATION_HASH_ID,
    {
      variables: { hash: hashId },
      client: ipanema,
    },
  );

  if (error) return null;

  return (
    <Box p={1}>
      <Box display="flex" alignItems="center">
        <Typography variant="subtitle2" className={classes.title}>
          &mdash;Recebíveis
        </Typography>
      </Box>
      <Divider className={classes.divider} />
      <Box py={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              first
              info
              title="Produto"
              value={data?.getCraReceivablesByOperationHashId?.operationProduct}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              info
              title="Categoria de Risco de Crédito"
              value={
                data?.getCraReceivablesByOperationHashId
                  ?.operationCreditRiskCategory
              }
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              info
              title="Devedor"
              value={data?.getCraReceivablesByOperationHashId?.operationDebtor}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg>
            <PaperPanelInfo
              info
              title="Tipo de Contrato"
              value={
                data?.getCraReceivablesByOperationHashId
                  ?.operationTypeofAgreement
              }
              loading={loading}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
